<template>
    <div>
        <create-task-headline
            title="Skapa nytt nummerfält"
            help-text="Ett nummerfält är ett fält man anger siffror i för att kunna markera som klar, det kan handla om antal meter eller dylikt."
        />

        <text-input
            v-model="body"
            label="Uppgift"
            name="body"
            :autofocus="true"
        />

        <add-dependency
            v-model="task_template_parent_id"
            :task-list-template="taskListTemplate"
        />

        <div class="button-group">
            <button
                type="button"
                class="btn btn-md is-ghost"
                @click="$emit('cancel')"
            >
                Avbryt
            </button>

            <checkbox-input
                v-model="createMoreOfThisType"
                class="my-md lg:my-0"
                value="1"
            >
                Skapa fler av denna typ
            </checkbox-input>

            <button
                type="button"
                class="btn btn-md is-primary"
                @click="create"
            >
                Skapa
            </button>
        </div>
    </div>
</template>
<script>
    import BaseCreate from './BaseCreate';
    import CreateTaskHeadline from './Headline';
    import AddDependency from './AddDependency';

    export default {
        components: {
            CreateTaskHeadline,
            AddDependency,
        },
        mixins: [BaseCreate],
        props: {
            taskListTemplate: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                body: '',
                type: 'number',
            };
        },
    };
</script>